"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _validate = require("@/utils/validate");
var _index = _interopRequireDefault(require("@/components/LangSelect/index.vue"));
var _queue = require("@/api/queue");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.validateUsername = (rule, value, callback) => {
      if (!(0, _validate.isValidEmail)(value)) {
        callback(new Error('Please enter valid email'));
      } else {
        callback();
      }
    };
    this.recoveryForm = {
      email: ''
    };
    this.recoveryRules = {
      email: [{
        validator: this.validateUsername,
        trigger: 'blur'
      }]
    };
    this.passwordType = 'password';
    this.loading = false;
    this.showDialog = false;
    this.otherQuery = {};
  }
  // @Watch('$route', { immediate: true })
  // private onRouteChange(route: Route) {
  //   // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
  //   // See https://github.com/vuejs/vue-router/pull/2050 for details
  //   const query = route.query as Dictionary<string>
  //   if (query) {
  //     this.redirect = query.redirect
  //     this.otherQuery = this.getOtherQuery(query)
  //   }
  // }
  // mounted() {
  //   if (this.recoveryForm.email === '') {
  //     (this.$refs.email as Input).focus()
  //   }
  // }
  //   private showPwd() {
  //     if (this.passwordType === 'password') {
  //       this.passwordType = ''
  //     } else {
  //       this.passwordType = 'password'
  //     }
  //     this.$nextTick(() => {
  //       (this.$refs.password as Input).focus()
  //     })
  //   }
  handleLogin() {
    this.$refs.recoveryForm.validate(async valid => {
      if (valid) {
        this.loading = true;
        try {
          await (0, _queue.sendRecoveryMail)(this.recoveryForm);
          this.$notify({
            title: 'Success',
            message: 'Recovery mail send',
            type: 'success',
            duration: 2000
          });
          this.$router.push({
            path: '/login'
            // query: this.otherQuery
          });
        } catch (error) {
          this.loading = false;
        }
      } else {
        return false;
      }
    });
  }
  getOtherQuery(query) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur];
      }
      return acc;
    }, {});
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'Recover Password',
  components: {
    LangSelect: _index.default
  }
})], default_1);
var _default = exports.default = default_1;